import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import reducerConfigGenerator from './reducerConfigGenerator';
export var crudInitialDefaultState = {
  item: null,
  items: [],
  total: 0,
  isLoading: false,
  isGetOneLoading: false,
  // loading: {
  //   getOne: false,
  //   getList: false,
  //   create: false,
  //   createMany: false,
  //   update: false,
  //   updateMany: false,
  //   delete: false,
  //   deleteMany: false,
  // },
  error: undefined,
  // error: {
  //   getOne: null,
  //   getList: null,
  //   create: null,
  //   createMany: null,
  //   update: null,
  //   updateMany: null,
  //   delete: null,
  //   deleteMany: null,
  // },
  queries: [],
  failedActions: [],
  queryOne: {}
};

var generator = function generator(_ref) {
  var name = _ref.name,
      _ref$surchargeReducer = _ref.surchargeReducer,
      surchargeReducer = _ref$surchargeReducer === void 0 ? function () {} : _ref$surchargeReducer,
      _ref$extendReducer = _ref.extendReducer,
      extendReducer = _ref$extendReducer === void 0 ? {} : _ref$extendReducer,
      _ref$extendedInitialS = _ref.extendedInitialState,
      extendedInitialState = _ref$extendedInitialS === void 0 ? {} : _ref$extendedInitialS;

  var initialState = _objectSpread(_objectSpread({}, crudInitialDefaultState), extendedInitialState);

  var reducerConfig = reducerConfigGenerator({
    name: name,
    surchargeReducer: surchargeReducer,
    initialState: initialState
  });
  return function crudReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var resource = action.resource;
    if (resource !== name) return state;

    if (reducerConfig[action.type]) {
      var res = reducerConfig[action.type](state, action);

      if (extendReducer && extendReducer[action.type]) {
        res = extendReducer[action.type](res, action, state);
      }

      return res;
    }

    return reducerConfig.default(state);
  };
};

export default generator;
export var generationHelper = function generationHelper(reducers) {
  var rv = {};
  reducers.forEach(function (reducer) {
    rv[reducer.name] = generator(reducer);
  });
  return rv;
};
//# sourceMappingURL=generator.js.map